module.exports = __webpack_public_path__ + "img/shoe3.92930a9e.png";